import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useRef,
} from "react";
import {
  _get_active_source_from_localStorage,
  _get_user_from_localStorage,
  get_section_source_id_from_local,
} from "../utils/LocalStorage";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { enqueueSnackbar } from "notistack";
import { get_user_details } from "../DAL/user/user";
import { get_active_source_features } from "../DAL/general-apis/general-apis";
import { switch_profile } from "../DAL/manage-users/manage-users";
import { baseUri } from "../config/config";
import { io } from "socket.io-client";
import { admin_default_setting_without_auth } from "../DAL/TalentSourceAPI/TalentSourceApi";

const IdsContext = createContext();
const get_active_source_list = _get_active_source_from_localStorage();
const get_source_inside_id = get_section_source_id_from_local();
const get_user = _get_user_from_localStorage();

const socketConfig = {
  reconnectionDelayMax: 10000,
};

let socket = { on: () => {}, emit: () => {}, off: () => {} };

export const IdsProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramsToken = searchParams.get("token");
  const firstSegment = location.pathname.split("/")[1];
  const [profileNewImage, setProfileNewImage] = React.useState();
  const [userAPIData, setUserAPIData] = useState(null);
  const [userToken, setUserToken] = useState(localStorage.getItem("token"));
  const [loadingDetails, setLoadingDetails] = useState(false); //
  const [refreshTrigger, setRefreshTrigger] = useState(false);

  const triggerRefresh = () => setRefreshTrigger((prev) => !prev); // Toggle flag to refresh consumers

  const [activeSourceList, setActiveSourceList] = useState([]);
  const [breadCrumb, setBreadCrumb] = useState([]);
  const [userInfo, setUserInfo] = useState(get_user);
  const [adminSetting, setAdminSetting] = useState(null);

  const [loadingDetail, setLoadingDetail] = useState(true);
  const [isRefresh, setIsRefresh] = useState(false);
  const [sideBarLoading, setSideBarLoading] = useState(true);

  const [findId, setFindId] = useState("");

  const [emailFallBackOpen, setEmailFallBackOpen] = useState(false);
  const [emailData, setEmailData] = useState("");

  const [openReportPost, setOpenReportPost] = useState(false);
  const [reportData, setReportData] = useState("");

  const [profileSwitchLoader, setProfileSwitchLoader] = useState(false);

  // =================== Socket Functionality =====================
  // ==============================================================

  const [updateFeedOnNotification, setUpdateFeedOnNotification] = useState(
    () => () => {}
  );

  const updateJobRef = useRef(() => {});
  const updateJobOnNotification = (data) => {
    updateJobRef.current(data); // always call the latest screen handler
  };
  const setUpdateJobOnNotification = (fn) => {
    updateJobRef.current = fn; // override old handler instantly
  };

  const paymentRequestRef = useRef(() => {});
  const updatePaymentRequestOnNotification = (data) => {
    paymentRequestRef.current(data); // always call the latest screen handler
  };
  const setUpdatePaymentRequestOnNotification = (fn) => {
    paymentRequestRef.current = fn; // override old handler instantly
  };

  const [
    updateSentAffiliatesOnNotification,
    setUpdateSentAffiliatesOnNotification,
  ] = useState(() => () => {});

  const [
    updateReceivedAffiliatesOnNotification,
    setUpdateReceivedAffiliatesOnNotification,
  ] = useState(() => () => {});

  const [updateUsersOnNotification, setUpdateUsersOnNotification] = useState(
    () => () => {}
  );

  const [
    updateInvitationListOnNotification,
    setUpdateInvitationListOnNotification,
  ] = useState(() => () => {});

  const [isConnected, setIsConnected] = useState(socket.connected);

  const START_SOCKET_FORCEFULLY = (user_id, token = null) => {
    let userToken = token || localStorage.getItem("token");
    if (Object.keys(socket).length > 0) {
      // check if the connection request from same user id
      let uri = socket.io?.uri;
      let is_same_user = uri?.includes(user_id);

      // --------------------------------------------------------------
      // if socket is not connected. Just connect the socket with user id

      if (!socket.connected) {
        socket = io(
          baseUri + `?user_id=${user_id}&token=${userToken}&role=client`,
          socketConfig
        );
        setIsConnected(true);
        return;
      }

      // --------------------------------------------------------------

      // if socket is connected but upcoming user id is for new user
      // close old connection and open new connection with new id.

      if (socket.connected && !is_same_user) {
        socket.disconnect();
        socket = io(
          baseUri + `?user_id=${user_id}&token=${userToken}&role=client`,
          socketConfig
        );
        setIsConnected(true);
      }

      // --------------------------------------------------------------
    } else {
      socket = io(
        baseUri + `?user_id=${user_id}&token=${userToken}&role=client`,
        socketConfig
      );
    }
  };

  const STOP_SOCKET_FORCEFULLY = () => {
    if (socket && socket.connected) {
      socket.disconnect();
    }
  };

  // useEffect(() => {
  //   // console.log(socket, "--socket");
  //   if (
  //     userInfo?._id &&
  //     !isConnected &&
  //     typeof socket === "object" &&
  //     Object.keys(socket).length > 0
  //   ) {
  //     socket.emit("client_live", userInfo._id);
  //     setIsConnected(true);
  //   }
  //   return () => {};
  // }, [userInfo, isConnected]);

  // ====================== socket functionality end =============
  // =============================================================

  const fetchAdminSettings = async () => {
    const data = await admin_default_setting_without_auth();
    if (data.code === 200) {
      await setAdminSetting(data?.admin_portal_settings);
    } else {
      enqueueSnackbar(data?.message, { variant: "error" });
    }
  };

  function moveIdToFirst(arr, id) {
    const index = arr.findIndex((item) => item._id === id);
    if (index > -1) {
      const [matched] = arr.splice(index, 1); // remove the matched item
      arr.unshift(matched); // put it at the start
    }
    return arr;
  }

  const handleSwitchProfile = async (id) => {
    if (id == userInfo.profile_id) return;
    setProfileSwitchLoader(true);
    const postData = {
      client_id: userInfo?._id,
      company_id: id,
    };
    const resp = await switch_profile(postData);
    if (resp.code == 200) {
      localStorage.setItem("token", resp.data.token);
      setUserToken(resp.data.token);
      setTimeout(async () => {
        await fetctUserDetail();
        navigate("/home");
        setProfileSwitchLoader(false);
      }, 1000);
    } else {
      await fetctUserDetail();
      enqueueSnackbar(resp.message, { variant: "error" });
      setProfileSwitchLoader(false);
    }
  };

  const fetctUserDetail = async () => {
    setLoadingDetails(true);

    try {
      const user_info = JSON.parse(localStorage.getItem("user")) || null;
      if (!user_info) return;

      let response = await get_user_details(user_info._id);
      console.log(response, "client details");
      if (response?.code === 200) {
        let obj = response.data.profile;
        if (response.data.profile_status == "deleted") {
          handleSwitchProfile(userInfo._id);
          return;
        }
        obj.profile_id = obj.profile_id || obj._id;

        if (
          obj.role == "internal_user" &&
          obj.navbar.length == 0 &&
          obj.profiles.length == 0
        ) {
          obj.has_any_access = false;
        } else {
          obj.has_any_access = true;
        }

        if (obj._id !== obj.profile_id) {
          obj.isCompanyProfile = true;
          obj.profiles = moveIdToFirst(obj.profiles, obj.profile_id);
          let companyObj = obj.profiles.find(
            (data) => data._id == obj.profile_id
          );
          obj.company_profile = companyObj;
          obj.company_access = companyObj.access;
        } else {
          obj.isCompanyProfile = false;
          obj.company_profile = {
            company_name: obj.company_name,
            profile_image: obj.profile_image,
            email: obj.email,
          };
        }
        localStorage.setItem("user", JSON.stringify(obj));
        // assign navbar to source to maintain compatibility as on some places source is used
        obj = {
          ...obj,
          source: obj?.navbar,
        };
        setUserInfo(obj);
        START_SOCKET_FORCEFULLY(obj.profile_id);
        setUserAPIData(obj);
        setActiveSourceList(obj?.navbar);
        setSideBarLoading(false);
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }

    setLoadingDetails(false);
  };

  const fetchSourceFeatures = async (sources) => {
    const postData = {
      source_slugs: sources.map((obj) => obj.source_slug),
    };
    const resp = await get_active_source_features(postData);
    if (resp.code == 200) {
      return resp;
    } else {
      return;
    }
  };

  const clearLocalStorageAndMoveLogin = () => {
    setUserAPIData(null);
    setUserInfo(null);
    STOP_SOCKET_FORCEFULLY();
    localStorage.clear();
    navigate("/login");
  };

  const handleGetActionByStatus = (post, type = "feed") => {
    if (
      (post?.action_by?.first_name || post?.action_by?.company_name) &&
      userInfo?.profile_id === post?.created_by?._id &&
      ((!userInfo.isCompanyProfile &&
        userInfo?._id === post?.created_by?._id) ||
        (userInfo.isCompanyProfile &&
          (userInfo?._id == post?.action_by?._id ||
            userInfo?.company_access?.[type]?.global_access)))
    ) {
      return true;
    }

    return false;
  };
  useEffect(() => {
    fetchAdminSettings();
    if (paramsToken) {
      setUserInfo(null);
      return;
    } else {
      fetctUserDetail();
    }
  }, []);

  useEffect(() => {
    if (activeSourceList && Array.isArray(activeSourceList)) {
      const matchedItem = activeSourceList.find(
        (item) => item.path === `/${firstSegment}`
      );
      setFindId(matchedItem ? matchedItem._id : "");
    }
  }, [firstSegment, activeSourceList]);

  useEffect(() => {
    setProfileNewImage(localStorage.getItem("image"));
  }, [localStorage.getItem("image")]);

  const handleGetSectorAccessValue = (key) => {
    return userInfo?.client_type?.some((obj) => obj?.sector?.[key]) || false;
  };

  const GetAccessOfCompany = (accessValue) => {
    if (
      (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
      (userInfo?.isCompanyProfile &&
        eval(`userInfo?.company_access?.${accessValue}`))
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleEmailClick = (email) => {
    const mailtoLink = `mailto:${email}`;

    // Create a hidden anchor tag and trigger click
    const link = document.createElement("a");
    link.href = mailtoLink;
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    let mailOpened = false;

    // If the user’s focus changes (e.g., Mail app opens), mark as opened
    const handleBlur = () => {
      mailOpened = true;
    };

    window.addEventListener("blur", handleBlur);

    // Wait for a moment to check if mail client opened
    setTimeout(() => {
      window.removeEventListener("blur", handleBlur);

      // If user didn’t leave the browser (no blur), show fallback
      if (!mailOpened) {
        setEmailData(email);
        setEmailFallBackOpen(true);
      }
    }, 5000);
  };

  const handleReportPost = (post, type, callBackFunction = () => {}) => {
    setReportData({
      post: post,
      report_to: type,
      callBackFunction: callBackFunction,
    });
    setOpenReportPost(true);
  };

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (
        (!event.key && !event.value) ||
        (event.key === "token" && userToken != event.newValue)
      ) {
        window.location.replace("/login");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []); // ✅ listens globally for localStorage changes

  //custom window event listner to use navigate in invokeAPI function.
  // Never Delete this Code
  useEffect(() => {
    const handler = (e) => navigate(e.detail);
    window.addEventListener("app:navigate", handler);
    return () => window.removeEventListener("app:navigate", handler);
  }, []);

  return (
    <IdsContext.Provider
      value={{
        activeSourceList,
        setActiveSourceList,
        findId,
        breadCrumb,
        setBreadCrumb,
        userInfo,
        setUserInfo,
        setUserAPIData,
        setUserToken,
        socket,
        START_SOCKET_FORCEFULLY,
        STOP_SOCKET_FORCEFULLY,
        clearLocalStorageAndMoveLogin,
        sideBarLoading,
        setProfileNewImage,
        profileNewImage,
        userAPIData,
        fetctUserDetail,
        handleSwitchProfile,
        loadingDetail,
        isRefresh,
        setIsRefresh,
        setAdminSetting,
        adminSetting,
        emailFallBackOpen,
        setEmailFallBackOpen,
        emailData,
        handleEmailClick,
        handleGetSectorAccessValue,
        GetAccessOfCompany,
        openReportPost,
        setOpenReportPost,
        setReportData,
        reportData,
        handleReportPost,
        profileSwitchLoader,
        setProfileSwitchLoader,
        handleGetActionByStatus,

        // socket update data functions
        updateJobOnNotification,
        setUpdateJobOnNotification,
        updateFeedOnNotification,
        setUpdateFeedOnNotification,
        updateSentAffiliatesOnNotification,
        setUpdateSentAffiliatesOnNotification,
        updateReceivedAffiliatesOnNotification,
        setUpdateReceivedAffiliatesOnNotification,
        updatePaymentRequestOnNotification,
        setUpdatePaymentRequestOnNotification,
        updateUsersOnNotification,
        setUpdateUsersOnNotification,
        updateInvitationListOnNotification,
        setUpdateInvitationListOnNotification,
      }}
    >
      {children}
    </IdsContext.Provider>
  );
};

export const useIds = () => useContext(IdsContext);
